import {
  ACTION_DELETE_SITE_ALIAS__REQUEST,
  ACTION_DELETE_SITE_ALIAS__SUCCESS,
  ACTION_DELETE_SITE_ALIAS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_ALIAS__REQUEST:
    case ACTION_DELETE_SITE_ALIAS__SUCCESS:
      return null;

    case ACTION_DELETE_SITE_ALIAS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
